module.exports = __webpack_public_path__ + "static/media/logout-black.9524015a.svg";